<template>
  <div>
    <Customer />
  </div>
</template>
<script>
import Customer from "../components/Customer.vue";

export default {
  components: {
    Customer,
  },
};
</script>
